export default {
  en: {
    supplementTypeList: 'Supplement Type List',
    editSupplementType: 'Edit Supplement Type',
    name: 'Name',
    saveChange: 'Save Changes',
    cancel: 'Cancel',
    updateSupplementTypeSuccessTitle: 'Success',
    updateSupplementTypeSuccessMessage: 'Add supplement type success.'
  },
  th: {
    supplementTypeList: 'ประเภทรายการเพิ่มเติม',
    editSupplementType: 'แก้ไขประเภทรายการเพิ่มเติม',
    name: 'ชื่อ',
    saveChange: 'บันทึก',
    cancel: 'ยกเลิก',
    updateSupplementTypeSuccessTitle: 'สำเร็จ',
    updateSupplementTypeSuccessMessage: 'แก้ไขประเภทรายการเพิ่มเติมสำเร็จ.'
  }
}
